import {useSelector} from "react-redux";
import {Link, useParams} from "react-router-dom";
import ComicList from "../ComicList";

const ComicContent = ({story}) => {
  const baseURL = 'https://www.neorice.com';

  let { comic, char } = useParams();

  const stories = useSelector(state => state.stories);
  const comicList = new ComicList(stories.comics[story]);
  const next = './../' + comicList.nextComic(comic, char);
  const filename = comicList.comicFilename(comic, char);
  const comicNumber = comicList.validComicNumber(comic, char);

  return (
    <Link to={next} id={'comic'}>
      <img src={`${baseURL}/${story}/${filename}`} alt={`${story} - ${comicNumber}`} />
    </Link>
  );
}

export default ComicContent;